import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

import Identity from './identity';
import { headers } from './constants';

/**
 * Use a nonce to verify a user's email address
 *
 * @param nonce
 *
 * @returns
 *
 * <details>
 * <summary>
 * On error (throws)
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/User_Registration/verifyEmail
 * ```
 *
 * </details>
 */

export default function verifyEmail(nonce: string): Promise<boolean | APIErrorResponse> {
  return fetch(`${Identity.apiOrigin}/identity/public/v1/email/verify/${nonce}`, {
    method: 'GET',
    headers
  })
    .then(JSONResponseHandler)
    .then(json => {
      if (json.success) {
        return true;
      } else {
        throw json;
      }
    });
}
